import { useState } from "react";
import { useDispatch } from "react-redux";
import { currentCompany } from "reducers/company/companySlice";
import axios from "utils/axiosConfig";

export function useSubscriptionEditPlan() {
    const dispatch = useDispatch();

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false);

    const editPlan = async ({ subscriptionId, packageId }) => {
        setIsLoading(true);
        setError(null);
        setIsSuccess(false);
        setData(null);

        try {
            const response = await axios.post(
                `/api/subscriptions/${subscriptionId}/edit-plan`,
                {
                    packageId,
                },
            );
            setData(response?.data);
            setIsSuccess(true);
            if (response?.data) dispatch(currentCompany(response.data));
        } catch (err) {
            const fallbackMsg = "Failed to changee plan.";
            const apiMsg = err?.response?.data?.message;
            setError(apiMsg || fallbackMsg);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        editPlan,
        isLoading,
        error,
        isSuccess,
        data,
    };
}
